import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { exportUser, getExampleFile, importUser } from '../Network/Report'
import { Loading, HeaderTitle } from '../Library'
import FileSaver from 'file-saver'
import dayjs from 'dayjs'
import "./ImportExport.css"
import { setDocumentTitle } from '../AppTitle'

function ImportExport() {
    const [isLoading, setLoading] = useState(false)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const [importFile, setImportFile] = useState(null)
    
    const lang = langCx.lang.user
    const errorLang = langCx.lang.error

    const onExport = () =>{
        exportUser(
            (data)=>{
                const blob =  new Blob([data])
                const currentDate = dayjs().format("DD-MM-YYYY_HH-mm")
                FileSaver.saveAs(blob, "lifelink_user_"+ currentDate +".xlsx")
            },
            (error)=>{
                notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
            }
        )
    }

    const onImport = () =>{
        setLoading(true)
        importUser(importFile,
            ()=>{
                setLoading(false)
                notifyCx.showNotify(lang.import_success, lang.import_success_desc, 0)
            },
            (error)=>{
                setLoading(false)
                console.log(error.response)
                notifyCx.showNotify(errorLang.something_wrong, error.response.data.message, 2)
            })
    }

    const getTemplate = () =>{
        getExampleFile(
            (data)=>{
                const blob =  new Blob([data])
                FileSaver.saveAs(blob, "lifelink_user_template.xlsx")
            },
            (error)=>{
                notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
            }
        )
    }

    useEffect(()=>{
        setDocumentTitle("Import and Export")
    },[])

    return (
        <>
        { isLoading ? <Loading/> : null }
        <div id="import-export">
            <HeaderTitle title={lang.import_export} isShowBack backTo="/user"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <div className="data-section">
                        <div className="title">{lang.import}</div>
                        <div className="desc">{lang.import_desc}</div>
                        <Form
                        onSubmit={(e)=>{
                            e.preventDefault()
                            onImport()
                        }}>
                            <Form.File
                            required
                            style={{marginBottom: 20}}
                            onChange={(e)=>{
                                let toUpload = e.target.files[0]
                                setImportFile(toUpload)
                                e.target.file = null
                            }}
                            />
                        
                            <Button
                            type="submit"
                            >
                                {lang.import_user}
                            </Button>
                            <a href="#"
                            style={{marginLeft: 20}}
                            onClick={(e)=>{
                                e.preventDefault()
                                getTemplate()
                            }}>
                                {lang.download_example}
                            </a>
                        </Form>
                    </div>
                    <hr/>
                    <div className="data-section">
                        <div className="title">{lang.export}</div>
                        <div className="desc">{lang.export_desc}</div>
                        <Button
                        onClick={()=>onExport()}
                        >
                            {lang.export_user}
                        </Button>
                    </div>
                    <hr/>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default ImportExport
